import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#007acd',
    },
    secondary: {
      main: '#F50057',
    },
  },
  components: {
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgb(0,122,205)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
        },
      },
    },
  },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
  components: {
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: '#2b485c',
        },
      },
    },
  },
});

export { lightTheme, darkTheme };
